import { RuleComponentDictionary, RuleComponentDictionaryRuleBase } from '../rules/models';
import { FORMTYPE } from './rules-dictionary.model';
import { FormSections, UiSections, RulesBase } from './schemas';

export class SchemaDictionary {
	/**
	 * Generates the object for the rulesBase
	 * 
	 * @param uiSections @see FormSections
	 * @param rulesBaseEnum @see RulesBase
	 */
	static generateRulesBases(uiSections: string[], rulesBaseEnum: any): RuleComponentDictionaryRuleBase {
		const uiSectionsRuleBase = {};
		uiSections.forEach(uiSection => {
			const sectionName = uiSection.toUpperCase();
			const ruleBase = rulesBaseEnum[sectionName] || null;

			const uiSectionRuleBase = [];
			uiSectionRuleBase[sectionName] = ruleBase;

			Object.assign(uiSectionsRuleBase, uiSectionRuleBase);
		});

		return uiSectionsRuleBase;
	}

	/**
	 * Creates the schema dictionary depending on 
	 * the Schema @see SchemaDictionaryNames constant name
	 */
	static generateSchemaDictionary(formName: string): RuleComponentDictionary {
		const item = new RuleComponentDictionary();
		const formSections = FormSections[formName];
		const uiSections = UiSections[formName];

		item.formSections = formSections;
		item.uiSections = uiSections.map(element => element.toUpperCase());
		item.formType = FORMTYPE[formName] || 'non existent';
		item.ruleBase = this.generateRulesBases(formSections, RulesBase[formName]);
		
		return item;
	}

}
